import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { roofTypeSchema } from "../../components/common/validations/Validation";
import TextField from "../../components/common/formInput/TextField";
import { options, message } from "../../components/common/utils/message";
import { alert, confirm } from "react-bootstrap-confirmation";
import { useLocation, useNavigate } from "react-router-dom";
import { failed, success } from "../../components/common/Toastify";
import queryString from 'query-string';
import { useDispatch } from "react-redux";
import TextArea from "../../components/common/formInput/TextArea";
import { addRoofType, listRoofType, updateRoofType } from "../../services/roofType";

const RoofTypeForm = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();

    const [resPayload, setResPayload] = useState();

    useEffect(() => {
        listRoofType({ page: 1 }, (data) => { setResPayload(data) }, dispatch);
    }, []);

    const roof_id = queryString.parse(location.search)
    const roofTypeData = resPayload && resPayload.docs.find((item) => item._id === roof_id.id)

    const initialData = {
        _id: roofTypeData ? roofTypeData._id : "",
        name: roofTypeData ? roofTypeData.name : "",
        price: roofTypeData ? roofTypeData.price : "",
        description: roofTypeData ? roofTypeData.description : "",
    };

    /**
     * @description Function is for add RoofType.
     * @param {object} data 
     */
    const _submitData = (data) => {
        try {
            addRoofType(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message)
                    navigate("/roof-type-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is for Update RoofType
     * @param {object} data 
     */
    const _updateData = async (data) => {
        try {
            updateRoofType(data, result => {
                if (result.status === "SUCCESS" && result.code === 200) {
                    success(result.message);
                    navigate("/roof-type-list")
                } else if (result.status === "ERROR" && result.code === 403) {
                    failed(result.message)
                }
            }, dispatch)
        } catch (e) {
            failed(e)
        }
    };

    /**
     * @description Function is For on Cancel Confirm Box.
     */
    const onCancel = async () => {
        const result = await confirm(message.cancelRoofTypeForm, options);
        if (result) {
            alert(message.canceledRoofForm);
            navigate("/roof-type-list");
        }
    };

    return (
        <div className="dashboard-inner p-b-0">
            <Formik
                initialValues={initialData}
                enableReinitialize
                validationSchema={roofTypeSchema}
                onSubmit={(values) => roofTypeData ? _updateData(values) : _submitData(values)}
            >
                {(formik) => (
                    <Form>
                        <div className="d-card m-b-25">
                            <div className="d-card-header">
                                <h5 className="d-card-heading">Add Roof Type</h5>
                            </div>
                            <div className="d-card-body p-b-0">
                                <div className="form-content">
                                    <div className="f-row alignTop">
                                        <div className="f-33">
                                            <TextField
                                                label="Roof Type Name"
                                                name="name"
                                                value={formik?.values?.name}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                        <div className="f-33">
                                            <TextField
                                                label="Price Per sqft"
                                                name="price"
                                                value={formik?.values?.price}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="f-row alignTop">
                                        <div className="f-66">
                                            <TextArea
                                                label="Roof Description"
                                                name="description"
                                                value={formik?.values?.description}
                                                onChange={formik.handleChange}
                                                required={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="d-card-bottom">
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-blue" type="submit">{roofTypeData ? "Edit Roof Type" : "Add Roof Type"}</button>
                            </div>
                            <div className="d-card-bottom-cell">
                                <button className="btn btn-grey" onClick={onCancel} type="button">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default RoofTypeForm;
